import React, { CSSProperties } from "react";

interface IndexValuesDescriptionProps {
  range: string;
  description: string;
  color: string;
  styles?: CSSProperties;
}

export const IndexValuesDescription = ({
    range,
    description,
    color,
    styles,
}: IndexValuesDescriptionProps) => {
    return (
        <div style={{ display: "flex", alignItems: "center", ...styles }}>
            <span
                style={{
                    display: "inline-block",
                    width: 13,
                    height: 13,
                    borderRadius: "50%",
                    backgroundColor: color,
                    marginLeft: 4,
                    marginRight: 5,
                }}
            ></span>
            <span>
                {range} {description}
            </span>
        </div>
    );
};
